import React from "react";

import AutocompleteSelectInput from "veneer/AutocompleteSelectInput";

import { getBooleanOptions } from "cortex/ui/src/util/select";

interface BooleanFieldProps {
  error?: boolean;
  field: {
    displayName?: string;
    name: string;
    value?: boolean | null;
  };
  handleChange: (value: boolean | null) => void;
  helperText?: string | null;
  isRequired: boolean;
  readOnly?: boolean;
}

interface BooleanOption {
  label: string;
  value: boolean;
}

const OPTIONS = getBooleanOptions() as BooleanOption[];

const BooleanField = ({
  error = false,
  field,
  handleChange,
  helperText,
  isRequired,
  readOnly = false,
}: BooleanFieldProps) => {
  const { name, value } = field;
  const selected =
    value === null || value === undefined
      ? undefined
      : OPTIONS.find((option) => option.value === value);

  const onChange = (_event: unknown, option: BooleanOption | null): void => {
    handleChange(option?.value ?? null);
  };

  return (
    <AutocompleteSelectInput<BooleanOption>
      dataTestId={`${name}.BooleanInput`}
      disabled={readOnly}
      getOptionLabel={(option) => option.label}
      inputProps={{
        error,
        helperText: helperText ?? undefined,
        label: field.displayName,
        required: isRequired,
        size: "small",
      }}
      isOptionEqualToValue={(option, selectedValue) =>
        option.value === selectedValue.value
      }
      onChange={onChange}
      options={OPTIONS}
      value={selected}
    />
  );
};

export { BooleanField };
